import { h } from 'preact'
import styled, { keyframes } from 'styled-components'
import R from 'ramda'

const spin = keyframes`
  0% { opacity: 1; }
  100% { opacity: 0.15; }
`

const Wrapper = styled.div`
  width: 100px;
  height: 100px;
`

const Inner = styled.div`
  position: relative;
  width: 64px;
  height: 64px;
  top: 50%;
  left: 50%;
`

const Bar = styled.div`
  animation: ${spin} 1.2s linear infinite;
  border-radius: 5px;
  background-color: #1F313A;
  position: absolute;
  width: 20%;
  height: 7.8%;
  top: -3.9%;
  left: -10%;
`

const Spinner = (props) => {
  const renderBar = (i) => {
    const barStyle = {}
    barStyle.WebkitAnimationDelay = `${(i - 12) / 10}s`
    barStyle.animationDelay = barStyle.WebkitAnimationDelay

    barStyle.WebkitTransform = `rotate(${i * 30}deg) translate(146%)`
    barStyle.transform = barStyle.WebkitTransform

    return <Bar style={barStyle} key={i} />
  }

  return (
    <Wrapper {...props}>
      <Inner>
        {R.times(renderBar, 12)}
      </Inner>
    </Wrapper>
  )
}

export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner.js